import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ArrowUp, ArrowDown, Minus } from 'lucide-react';
import DashboardCard from './DashboardCard';
import { formatTry } from '../constants';

const Table = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto auto;
  gap: 6px 12px;
  font-size: 12px;
  align-items: center;
`;

const Head = styled.div`
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #9CA3AF;
`;

const MetricName = styled.div`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
`;

const Val = styled.div`
  font-weight: 700;
  color: #52514e;
  text-align: right;
`;

const Delta = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 3px;
  font-weight: 800;
  color: #52514e;
`;

function DeltaCell({ current, prev }) {
  const delta = prev > 0 ? Math.round(((current - prev) / prev) * 100) : null;
  const Icon = delta === null || delta === 0 ? Minus : delta > 0 ? ArrowUp : ArrowDown;
  return (
    <Delta>
      <Icon size={11} />
      {delta === null ? '—' : `%${Math.abs(delta)}`}
    </Delta>
  );
}

export default function MonthComparisonCard({ slice }) {
  const { t, i18n } = useTranslation();
  const s = slice.data;

  const monthName = (offset) => {
    if (!s) return '';
    const d = new Date(s.year, s.month - 1 + offset, 1);
    return d.toLocaleDateString(i18n.language, { month: 'short' });
  };

  const rows = s ? [
    { key: 'total', label: t('expenseDashboard.comparison.total'), cur: s.approvedTotal, prev: s.prevApprovedTotal, fmt: formatTry },
    { key: 'count', label: t('expenseDashboard.comparison.count'), cur: s.approvedCount, prev: s.prevApprovedCount, fmt: (v) => v },
    { key: 'avg', label: t('expenseDashboard.comparison.avgPerTxn'), cur: s.avgPerTransaction, prev: s.prevAvgPerTransaction, fmt: formatTry },
  ] : [];

  return (
    <DashboardCard
      cardKey="onceki-ay-karsilastirma"
      title={t('expenseDashboard.comparison.title')}
      meta={s ? `${monthName(0)} / ${monthName(-1)}` : null}
      span={4}
      spanMd={3}
      loading={slice.loading}
      empty={!s}
    >
      {s && (
        <Table>
          <Head />
          <Head>{monthName(0)}</Head>
          <Head>{monthName(-1)}</Head>
          <Head>Δ</Head>
          {rows.map((r) => (
            <React.Fragment key={r.key}>
              <MetricName>{r.label}</MetricName>
              <Val>{r.fmt(r.cur)}</Val>
              <Val>{r.fmt(r.prev)}</Val>
              <DeltaCell current={r.cur} prev={r.prev} />
            </React.Fragment>
          ))}
        </Table>
      )}
    </DashboardCard>
  );
}
